import redirect from "@rill/redirect";
import get from "lodash/get";
import rill from "rill";
import ensureCoach from "../../middleware/ensure-coach";
import ensurePaid from "../../middleware/ensure-paid";
import ensureSetup from "../../middleware/ensure-setup";
import ensureUser from "../../middleware/ensure-user";
import loadActivityFeed from "../../middleware/loadActivityFeed";
import { getNewsLoaderArgs } from "../../parts/news-drawer/constants";
import Calendar from "./calendar";
import Metrics from "./metrics";
import Nutrition from "./nutrition";
import Profile from "./profile";
import Programs from "./programs";

const AthletePortal = (app) => {
  app.get("/athlete-portal", redirect("/athlete-portal/profile")).at(
    "/athlete-portal/*",
    ensureUser,
    ensureCoach,
    ensurePaid,
    loadActivityFeed,
    rill()
      .get(ensureSetup)
      .use(async ({ load, req }, next) => {
        await Promise.all([
          load("listNotifications", { limit: 5 }),
          load("unreadNewsCount"),
          ...(get(req.query, "modal.type") === "whats-new"
            ? [load("listNews", getNewsLoaderArgs(req.query.newsSkip))]
            : []),
        ]);
        return next();
      })
      .setup(Calendar)
      .setup(Metrics)
      .setup(Profile)
      .setup(Programs)
      .setup(Nutrition)
  );
};

export default AthletePortal;
